import PropTypes from "prop-types";
import { connect } from "react-redux";
import PaymentContact from "app/pages/Booking/Payment/PaymentContact";
import { bindActionCreators } from "redux";
import { getProfile } from "app/pages/Account/Profile/profileActionCreators";
import { PROFILE_CODE_STATUS } from "app/constants";
import withRouter from "app/utils/hocs/withRouter";
import { getCurrentShop } from "app/reducers/shopSelector";
import { shouldGetProfileAtPayment } from "app/pages/Account/Profile/profileSelector";
import usePrevious from "app/utils/hooks/usePrevious";
import { useCallback, useEffect } from "react";
import { useAnalytics } from "app/utils/analytics/useAnalytics";
import { getCredentials } from "app/utils/auth";
import { isOperatorMode } from "app/pages/Auth/authSelectors";

const PaymentContactContainer = props => {
	const { token, getProfile, shouldGetProfileAtPayment } = props;

	const { track } = useAnalytics();

	const prevToken = usePrevious(token);

	const fetchProfile = useCallback(() => {
		if (shouldGetProfileAtPayment) {
			getProfile()
				.then(() => {
					// on doit absolument récupérer les crédits après un getProfile
					// car le back end met à jour les crédits lors du getProfile
					track("payment_fetch_profile_success");
				})
				.catch(() => {
					track("payment_fetch_profile_failed");
				});
		}
	}, [shouldGetProfileAtPayment]);

	useEffect(() => {
		fetchProfile();
	}, []);

	useEffect(() => {
		if (prevToken && token && prevToken !== token) {
			fetchProfile();
		}
	}, [token, prevToken]);

	return <PaymentContact {...props} />;
};

PaymentContactContainer.propTypes = {
	getProfile: PropTypes.func,
	token: PropTypes.string,
	shouldGetProfileAtPayment: PropTypes.bool,
};

const mapStateToProps = state => {
	const { token } = getCredentials();
	const email = state.email;

	const isOperator = isOperatorMode(state);

	return {
		strategy: state.partner.strategy,
		token: token,
		shop: getCurrentShop(state),
		isLoading: state.profile.status === PROFILE_CODE_STATUS.LOADING,
		shouldDisableEmailField: shouldGetProfileAtPayment() && email && !isOperator,
		shouldFetchProfile: shouldGetProfileAtPayment(),
		confidentialiteDocumentName: state.documents.confidentialite,
	};
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators({ getProfile }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PaymentContactContainer));
